import { getChannel } from '@packages/service-worker/src/utils/getChanelMessage';

export const channel = getChannel();
